export enum PalantirButtonThemeEnum {
  dashed = 'dashed',
  outline = 'outline',
  soft = 'soft',
  solid = 'solid',
  transparent = 'transparent',
}

export type PalantirButtonTheme = keyof typeof PalantirButtonThemeEnum;

export enum PalantirButtonLayoutEnum {
  default = 'default',
  icon = 'icon',
  prefix = 'prefix',
  suffix = 'suffix',
}

export type PalantirButtonLayout = keyof typeof PalantirButtonLayoutEnum;

export enum PalantirButtonShapeEnum {
  default = 'default',
  rounded = 'rounded',
}

export type PalantirButtonShape = keyof typeof PalantirButtonShapeEnum;

export enum PalantirButtonVariantEnum {
  negative = 'negative',
  neutral = 'neutral',
  positive = 'positive',
}

export type PalantirButtonVariant = keyof typeof PalantirButtonVariantEnum;
